import { Stack, Typography } from "@mui/material";
import { FormikDecimalTextField } from "@shared";
import { FormikProps, FormikValues } from "formik";

interface HoursInputFieldProps<T extends FormikValues> {
  formik: FormikProps<T>;
  fieldName: keyof T & string;
  label: string;
  labelWidth?: number;
  unit: string;
  required?: boolean;
  width?: number;
  minValue?: number;
  id?: string;
}

const DEFAULT_FIELD_WIDTH = 70;
const LABEL_OFFSET = 1.5;

export function HoursInputField<T extends FormikValues>({
  formik,
  fieldName,
  label,
  labelWidth,
  unit,
  required,
  width = DEFAULT_FIELD_WIDTH,
  minValue = 0,
  id = fieldName,
}: HoursInputFieldProps<T>) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <Typography
        component="label"
        htmlFor={id}
        variant="body2"
        width={labelWidth}
        color="text.secondary"
        pt={LABEL_OFFSET}
      >
        {label}
      </Typography>
      <FormikDecimalTextField
        formik={formik}
        fieldName={fieldName}
        minValue={minValue}
        required={required}
        textFieldProps={{ id }}
        formControlProps={{ sx: { width } }}
      />
      <Typography variant="body2" color="text.secondary" pt={LABEL_OFFSET}>
        {unit}
      </Typography>
    </Stack>
  );
}
